import { Button } from '@ifood/pomodoro-components';
import { FormattedMessage } from 'gatsby-plugin-intl';
import React, { FC } from 'react';

import { ROUTER_PATHS } from '@constants/router';
import { Actions, Link } from 'modules/UI';

const LoggedOutActions: FC = () => (
  <Actions>
    <Link noStyles dataTestId="sign-in-link" href={ROUTER_PATHS.SIGN_IN}>
      <Button tabIndex={-1} variant="secondary">
        <FormattedMessage id="core.header.actions.sign-in" />
      </Button>
    </Link>

    <Link noStyles dataTestId="sign-up-link" href={ROUTER_PATHS.SIGN_UP}>
      <Button tabIndex={-1}>
        <FormattedMessage id="core.header.actions.sign-up" />
      </Button>
    </Link>
  </Actions>
);

export default LoggedOutActions;
